export {
    KINGSPAN_CONFIGURATION_FORM_SERVICE_NAME,
    KINGSPAN_CONFIGURATION_FORM_SERVICE_PROVIDER_NAME,
    KingspanConfigurationFormService,
    KingspanConfigurationFormServiceProvider,
} from './kingspan-configuration-form.service'

export { KINGSPAN_CONFIGURATION_FORM_SERVICES_MODULE_NAME } from './kingspan-confguration-form.service.module'